define('utils/mail_html_utils',[], function () {
  'use strict';

  var BLANK_PARAGRAPH = /<p(\s[^>]*)?>(\s|&nbsp;)*(<br\s*\/?>)?(\s|&nbsp;)*<\/p>/gi;
  var EMPTY_PARAGRAPH = /<p(\s[^>]*)?>\s*<\/p>/gi;

  return {
    // Flattens the <p> blocks a Trumbowyg composer produces into <br>-ended
    // lines, so a mail renders with the same spacing in every client (and as
    // in the composer, which shows paragraphs without margins). A blank
    // paragraph (<p><br></p>, <p>&nbsp;</p> — what a paste from
    // Outlook/Word/Gmail yields) is one empty line, not two. <div>s are left
    // alone: they also come from signatures and forwarded HTML mails, where
    // turning them into breaks would add lines.
    normalize: function (html) {
      return (html || '')
        // A truly empty paragraph renders nothing; a blank one, one line.
        .replace(EMPTY_PARAGRAPH, '')
        .replace(BLANK_PARAGRAPH, '<br>')
        // A trailing <br> inside a paragraph already ends the line the
        // paragraph ends.
        .replace(/<br\s*\/?>\s*<\/p>/gi, '</p>')
        .replace(/<p(\s[^>]*)?>/gi, '')
        .replace(/<\/p>/gi, '<br>');
    },

    // Separator that leaves exactly one empty line between the current body
    // and appended content (signature): after a paragraph a single blank
    // paragraph, after inline text two breaks.
    blankLineAfter: function (html) {
      return /<\/p>\s*$/i.test(html || '') ? '<p><br></p>' : '<br><br>';
    }
  };
});

